module.exports = __webpack_public_path__ + "static/media/year-special-offer.d6775c57.png";